import React from "react";
import { Typography } from "@mui/material";
import RpImageTextInline from "@/components/RpImageTextInline";

type ConfirmLocationItemProps = {
  imgSrc?: string;
  svgIcon?: string;
  label?: React.ReactNode;
  value?: React.ReactNode;
  valueClass?: string;
  valueProps?: Record<string, any>;
  children?: React.ReactNode;
};

const ImageTextInline = RpImageTextInline as React.ComponentType<any>;

function ConfirmLocationItem({
  imgSrc,
  svgIcon,
  label,
  value,
  valueClass = "",
  valueProps,
  children,
}: ConfirmLocationItemProps) {
  return (
    <div className="confirm-location-item">
      <ImageTextInline
        image={imgSrc}
        svgIcon={svgIcon}
        imageProps={{ color: "primary" }}
        className="icon-img mr-1"
        text={
          <>
            <div className="label">{label}</div>
            {children}
          </>
        }
      />

      <Typography
        variant="body2"
        className={`value ${valueClass}`}
        {...valueProps}
      >
        {value}
      </Typography>
    </div>
  );
}

export default ConfirmLocationItem;
